<template>
  <v-container fluid class="pa-0 col-12 justify-center">
    <v-app-bar flat color="red-darken-3">
      <v-app-bar-title class="hidden-sm-and-down">
        {{ $t("lekoAI.subtitle2") }}
      </v-app-bar-title>
      <v-divider class="mx-5 hidden-sm-and-down" inset vertical />
    </v-app-bar>

    <v-row row class="pa-3">
      <v-col xs="8" md="7" lg="7" class="align-center pt-5">
        <img
          v-if="imageUrl || image.src"
          :src="imageUrl || image.src"
          alt="Uploaded Image"
          width="500"
          contain
          @mousemove="zoomIn"
          @mouseleave="zoomOut"
        />
        <div v-else class="default-image-text">
          {{ $t("test_img_here") }}
        </div>
      </v-col>

      <v-col xs="4" md="5" lg="5" class="mt-4">
        <h2 class="mt-4">
          {{ $t("upload_image") }}
        </h2>
        <input
          ref="fileInput"
          type="file"
          accept="image/*"
          @change="handleFileUpload"
        />
        <br /><br />
        {{ $t("or") }}
        <br /><br />
        <v-form class="mt-2">
          <v-text-field
            v-model="imageUrl"
            class="mt-2"
            :label="$t('enter_img_url')"
            variant="outlined"
          />

          <v-btn
            color="primary"
            class="mt-4"
            :loading="loading"
            :disabled="!imageUrl && !image.src"
            @click="getImageDetails"
          >
            {{ $t("classify_image") }}
            <v-icon end> mdi-image-search-outline </v-icon>
          </v-btn>
          <div v-if="predictions.length > 0" class="mt-4">
            <h3 class="mb-2 mt-2">
              {{ $t("top_3_predictions") }}
            </h3>
            <ul>
              <li
                v-for="(prediction, index) in predictions.slice(0, 3)"
                :key="index"
              >
                <strong>{{ prediction.tagName }}</strong
                >: {{ (prediction.probability * 100).toFixed(2) }}%
              </li>
            </ul>
          </div>
        </v-form>
      </v-col>
    </v-row>
    <div class="pa-3">
      <v-col xs="12">
        <div class="response-card">
          <!-- <div class="d-flex col-12"> -->
          <h2 class="col-6 pl-0 ml-0">
            {{ $t("response") }}
          </h2>
          <!-- <button
              class=" col-6 text-end copy-button ml-auto"
              @click="copyToClipboard"
            >
              <v-icon>{{ copied ? 'mdi-check' : 'mdi-content-copy' }}</v-icon>
            </button> -->
          <!-- </div> -->
          <div v-if="partDetails" class="col-12 d-flex text-end justify-end">
            {{ copied ? "Copied!" : "" }}
          </div>
          <p v-if="partDetails">
            {{ $t("img_details_response_title") }}
          </p>
          <p v-else>
            {{ $t("img_details_here") }}
          </p>
          <div v-if="partDetails" v-html="partDetails" />
        </div>
      </v-col>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
import zoom from "../utils/zoom";
import { dataURLtoBlob } from "../utils/files";

export default {
  data() {
    return {
      image: {
        type: null, // 'string' | 'file'
        src: null,
        url: null,
      },
      loading: false,
      predictions: [],
      copied: false,
      partDetails: null,
      imageUrl: "",
      imageValid: false,
      rotation: 0,
    };
  },
  watch: {},
  methods: {
    handleFileUpload() {
      // Get the file input element using the ref
      const { fileInput } = this.$refs;

      if (fileInput.files.length > 0) {
        const image = fileInput.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
          this.image = { type: "file", src: event.target.result, url: null };
        };
        reader.readAsDataURL(image);
      }
    },
    copyToClipboard() {
      const text = `Type: ${this.partDetails.type}\nOEM Number: ${this.partDetails.oemNumber}\nBrand: ${this.partDetails.brand}\nSources: ${this.partDetails.sources.map((s) => s.url).join(", ")}\nSearch Suggestions: ${this.partDetails.searchSuggestions.join(", ")}`;

      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.copied = true;
          setTimeout(() => (this.copied = false), 2000);
        })
        .catch(() => {});
    },
    // https://api.lekotech.com/images?q=parts/2025/02/19574ff5e7d3f1e25c0c26cf98619786c45e39b187e.jpeg
    async getImageDetails() {
      if (!this.imageUrl && !this.image.src) {
        return;
      }

      this.loading = true;

      try {
        let formData;
        const config = {};

        if (this.image.type === "file") {
          // Send file as FormData
          formData = new FormData();
          formData.append(
            "image",
            dataURLtoBlob(this.image.src),
            "uploaded-image.jpg",
          );
          config.headers = { "Content-Type": "multipart/form-data" };
        } else {
          // Send URL as JSON
          formData = { image: this.imageUrl };
        }

        const res = await axios.post(
          // 'https://oemlabeldetectionv4-97815853843.us-central1.run.app/get-image-detail', // gemini 1.5
          "https://new-extract-model-v2-97815853843.us-central1.run.app/get-image-detail", // gemini 2.5
          // 'http://localhost:8081/get-image-detail',
          formData,
          config,
        );

        this.partDetails = res.data.data.replace(/\n/g, "<br>");
      } catch {
      } finally {
        this.loading = false;
      }
    },
    zoomIn(event) {
      zoom.zoomIn(2.4, event, this.rotation);
      const img = event.target;

      img.classList.add("zoomed");
    },
    zoomOut(event) {
      zoom.zoomOut(event, this.rotation);
      const img = event.target;

      img.classList.remove("zoomed");
    },
  },
};
</script>

<style scoped>
.zoomed {
  position: relative;
  z-index: 9999;
  transform: scale(1.5);
  transition: transform 0.2s ease-in-out;
}
.default-image-text {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  background-color: #ccc;
  color: #555;
  font-size: 18px;
  font-weight: bold;
}
.response-card {
  background-color: #e9eef6;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
h2 {
  font-size: 18px;
  font-weight: bold;
}
h3 {
  font-size: 16px;
  margin-top: 12px;
}
ul {
  list-style: none;
  padding: 0;
}
li {
  margin: 5px 0;
}
.search-suggestions {
  background-color: #fff;
  padding: 2px;
  border-radius: 10px;
}
.grounding-sources {
  background-color: #fff;
  padding: 2px;
  border-radius: 10px;
}
.grounding-sources span {
  cursor: help;
}
.search-tags {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.tag {
  background: #eee;
  padding: 5px 10px;
  border-radius: 5px;
}
.copy-button {
  display: contents !important;
}
</style>
